import homeView from './index'
import searchView from './search'
import dateView from './date'

const routes = {
  path: 'tour',
  name: 'Private/Tour',
  component: homeView,
  redirect: { name: 'Private/Tour/Search' },
  children: [
    {
      path: 'search',
      name: 'Private/Tour/Search',
      component: searchView
    },
    {
      path: 'date/:tour/:date',
      name: 'Private/Tour/Date',
      component: dateView
    }
  ]
}

export default routes
